import React, { ReactNode } from 'react';
import CardCollapse from "@/pages/datalab/components/CardCollapse";
import classNames from "classnames";
import TipContext from "@home/components/TipContext";
import './index.scss';

/**
 * 图表配置中经常新增 可折叠的配置项
 * 所以结合一些固定样式和交互 写一个可复用的UI组件
 */

// TipContext 组件的 props 类型定义
interface ITipContextProps {
  tipText?: string | ReactNode;
  className?: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  AWidth?: string | number;
  style?: React.CSSProperties;
  type?: {
    default?: string;
    hover?: string;
  };
  selected?: boolean;
  onClick?: () => void;
  overlayClassName?: string;
  overlayMaxHeight?: string | number;
}

// ConfigCollapseCard 组件的 props 类型定义
interface IConfigCollapseCardProps {
  /** 标题内容 */
  title: ReactNode;
  /** 提示信息配置 */
  info?: ITipContextProps;
  /** 自定义类名 */
  className?: string;
  /** 子组件 */
  children?: ReactNode;
  /** 默认展开哪个面板 */
  defaultActiveIds?: string[];
  /** 当前激活的面板 */
  activeIds?: string[];
  /** 面板切换时的回调 */
  onChange?: (activeIds: string[]) => void;
}

const ConfigCollapseCard: React.FC<IConfigCollapseCardProps> = (props) => {
  const { title, info, className, children, ...rest } = props;
  
  const TitleComponent = (
    <div className={'dbl-config-collapse-card-title'}>
      {title}
      {info ? (
        <TipContext {...info} />
      ) : null}
    </div>
  );
  
  return (
    <CardCollapse
      title={TitleComponent}
      defaultActiveIds={['1']}
      className={classNames('dbl-config-collapse-card', className)}
      {...rest}
    >
      {children}
    </CardCollapse>
  );
};


export default ConfigCollapseCard;